import { Fragment } from 'react';

import PropTypes from 'prop-types';

import { H2Section } from 'bloko/blocks/header';
import VSpacing from 'bloko/blocks/vSpacing';

const TitleBlock = ({ children }) => (
    <Fragment>
        <H2Section lite>{children}</H2Section>
        <VSpacing base={4} />
    </Fragment>
);

TitleBlock.propTypes = {
    children: PropTypes.node,
};

export default TitleBlock;
